export function getToken() {
  const raw = localStorage.getItem('token');
  if (!raw || raw === 'null' || raw === 'undefined') return null;
  return raw;
}

export function getUserRole() {
  const token = getToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.isAdmin ? 'admin' : 'client';
  } catch {
    return null;
  }
}

export function getUserEmail() {
  const token = getToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.email || null;
  } catch {
    return null;
  }
}
